module.exports = __webpack_public_path__ + "static/media/gallery-3.ee1d2b97.JPG";